/* Lucky Girl Paris — mouvement v2. Sans dependance, tolerant aux pannes. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Un contenu invisible est pire qu'un contenu fixe : si un observateur
     rate sa cible, on revele tout ce qui est proche du viewport a 1,4 s. */
  function safetyNet() {
    setTimeout(function () {
      var sel = '.lgp-reveal:not(.is-in), .lgp-rise:not(.is-in), .lgp-wipe:not(.is-in), .lgp-split:not(.is-in)';
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (n) {
        var r = n.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.4) n.classList.add('is-in');
      });
    }, 1400);
  }

  function observer(margin) {
    return new IntersectionObserver(function (entries, io) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: margin || '120px 0px 0px 0px', threshold: 0 });
  }

  /* ----------------------------------------------- cartes et collections */
  function reveal() {
    var nodes = document.querySelectorAll(
      'product-card, .product-card, [class*="collection-card"], .lgp-watch'
    );
    if (!nodes.length) return 0;

    if (REDUCED || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) {
        n.classList.add('lgp-reveal', 'is-in');
      });
      return nodes.length;
    }

    var io = observer();
    var i = 0;
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.classList.contains('lgp-reveal')) return;
      n.classList.add('lgp-reveal');
      n.style.setProperty('--lgp-i', (i % 4).toString());
      i++;
      io.observe(n);
      var img = n.querySelector('img');
      if (img && !img.classList.contains('lgp-wipe')) {
        img.classList.add('lgp-wipe');
        img.style.setProperty('--lgp-i', (i % 4).toString());
        io.observe(img);
      }
    });

    safetyNet();
    return i;
  }

  /* ------------------------------------------ titres et blocs editoriaux */
  function riseBlocks() {
    if (REDUCED) return 0;
    var nodes = document.querySelectorAll(
      '.shopify-section h2:not(.visually-hidden):not(.lgp-rise), .shopify-section h3:not(.visually-hidden):not(.lgp-rise)'
    );
    if (!nodes.length) return 0;
    var io = observer('60px 0px 0px 0px');
    var n = 0;
    Array.prototype.forEach.call(nodes, function (h) {
      if (h.closest('.hero-wrapper')) return;
      h.classList.add('lgp-rise');
      io.observe(h);
      n++;
    });
    return n;
  }

  /* --------------------------------------------- titre hero mot par mot */
  var splitDone = false;
  function splitTitles() {
    if (REDUCED || splitDone) return 0;
    splitDone = true;
    /* Horizon rend le titre du hero dans un <p>, pas dans un h1 : on cible
       le plus gros texte du bloc plutot qu'une balise. */
    var titles = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.hero-wrapper, .hero'),
      function (hero) {
        var best = null, bestSize = 0;
        Array.prototype.forEach.call(
          hero.querySelectorAll('h1, h2, p, span, div'),
          function (el) {
            if (el.children.length) return;
            if (el.classList.contains('lgp-split')) return;
            if (el.classList.contains('lgp-w')) return;
            if (el.closest('.lgp-split')) return;
            var txt = (el.textContent || '').trim();
            if (txt.length < 6 || txt.length > 90) return;
            var size = parseFloat(getComputedStyle(el).fontSize) || 0;
            if (size > bestSize) { bestSize = size; best = el; }
          }
        );
        if (best && bestSize >= 30) titles.push({ el: best, size: bestSize });
      }
    );
    titles.sort(function (a, b) { return b.size - a.size; });
    titles = titles.slice(0, 1).map(function (x) { return x.el; });
    var done = 0;

    Array.prototype.forEach.call(titles, function (h) {
      if (h.classList.contains('visually-hidden')) return;
      if (h.querySelector('img, svg, a')) return;

      var words = (h.textContent || '').trim().split(/[ \t\n]+/);
      if (!words.length || words.length > 18) return;

      h.textContent = '';
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'lgp-w';
        span.style.setProperty('--lgp-wi', i.toString());
        span.textContent = w;
        h.appendChild(span);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });

      h.classList.add('lgp-split');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { h.classList.add('is-in'); });
      });
      done++;
    });

    return done;
  }

  /* ------------------------------ inclinaison legere des cartes produit */
  function tilt() {
    if (REDUCED) return 0;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return 0;
    var cards = document.querySelectorAll('product-card:not([data-lgp-tilt]), .product-card:not([data-lgp-tilt])');
    var n = 0;
    Array.prototype.forEach.call(cards, function (c) {
      c.setAttribute('data-lgp-tilt', '1');
      n++;
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        c.style.transform = 'perspective(900px) rotateY(' + dx * 2.4 + 'deg) rotateX(' + -dy * 2.4 + 'deg)';
      });
      c.addEventListener('pointerleave', function () { c.style.transform = ''; });
    });
    return n;
  }

  /* -------------------------------------------- aimantation des boutons */
  function magnet() {
    if (REDUCED) return 0;
    var targets = document.querySelectorAll('.button:not(.lgp-magnet), [class*="button-custom"]:not(.lgp-magnet)');
    var n = 0;
    Array.prototype.forEach.call(targets, function (el) {
      el.classList.add('lgp-magnet');
      n++;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        el.style.transform = 'translate(' + dx * 5 + 'px,' + dy * 4 + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    return n;
  }

  /* ------------------- en-tete : compacte au defilement, masque en bas */
  var scrollBound = false;
  function headerState() {
    if (scrollBound) return;
    scrollBound = true;
    var last = 0;
    var ticking = false;

    function tick() {
      var y = window.scrollY || 0;
      document.body.classList.toggle('lg-scrolled', y > 24);
      var down = y > last && y > 260;
      document.body.classList.toggle('lg-hide-header', !REDUCED && down);
      last = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(tick);
    }, { passive: true });

    tick();
  }

  /* ----------------------------------- cascade dans le tiroir de menu */
  function drawerStagger() {
    var items = document.querySelectorAll('[class*="menu-drawer"] li:not([data-lgp-s])');
    var i = 0;
    Array.prototype.forEach.call(items, function (li) {
      li.setAttribute('data-lgp-s', '1');
      li.style.setProperty('--lgp-i', (i % 10).toString());
      i++;
    });
    return i;
  }

  /* ----------------------------------------------------------- init */
  function init() {
    try {
      reveal();
      riseBlocks();
      splitTitles();
      tilt();
      magnet();
      headerState();
      drawerStagger();
    } catch (e) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.lgp-reveal, .lgp-rise, .lgp-wipe'),
        function (n) { n.classList.add('is-in'); }
      );
    }
  }

  document.documentElement.classList.add('lgp-on');
  document.body && document.body.classList.add('lg-boot');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Horizon remplace document.body apres le premier rendu : on observe
     documentElement, sinon l'observateur surveille un noeud detache. */
  var pending = null;
  var mo = new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(init, 180);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  [250, 700, 1500, 3000].forEach(function (ms) { setTimeout(init, ms); });
})();
